import React from 'react';
import Box from '@mui/material/Box';
// import { MenuComponent } from '../components/Menu';
// import NavBar from '../components/Navbar/Navbar';
import Header from "components/header";
import Sidebar from "components/sidebar";
import MessagingPage from '../components/Messaging/MessagingPage';

const Messages = ({ collapsed = false, setCollapsed }) => {

  return (
    <>
      {/* <Box sx={{ width: collapsed ? '7%' : '17.5%' }}>
        <MenuComponent collapsed={collapsed} setCollapsed={setCollapsed} />
      </Box> */}
      <Box
        sx={{
          display: 'flex',
          height: '100vh',
          // width: '100vw',
          // backgroundColor: 'orange',
          // border: '10px solid orange' ,
          // boxSizing: 'border-box',
          // width: '100vw',
          // maxWidth: '100vw'
          // margin: 0,
          // padding: 0
        }}
      >
        {/* <Box 
          sx={{ 
            width: collapsed ? '7%' : '17.5%',
            flexShrink: 0 
          }}
        >
          <MenuComponent collapsed={collapsed} setCollapsed={setCollapsed} />
        </Box> */}
          <Sidebar />

        <Box
          sx={{
            flexGrow: 1,
            display: 'flex',
            flexDirection: 'column',
            width: collapsed ? '93%' : '82.5%',
          }}
        >
          {/* <NavBar /> */}
          <Header />
          <MessagingPage />
          {/* <SettingsContainer/> */}
        </Box>
      </Box>
    </>

  );
};

export default Messages;